import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAllConfigs } from 'actions/utils';
import { updateConfigs } from 'api/utils';
import { PaddingWrapper, PlainButton } from 'components/styled-components';
import Select from 'react-select';
import { Intent, InputGroup, FormGroup } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import customStyles from 'utils/select-styles';

const ValidationSchema = Yup.object().shape({
  contact_email: Yup.string()
    .email('Invalid email')
    .max(200, 'Too Long!')
    .required('Required'),
  days_until_expiration: Yup.number()
    .min(1, 'Must be greater than 0.')
    .required('Required'),
  expiration_time: Yup.number()
    .min(1, 'Must be greater than 0.')
    .required('Required'),
  max_passing_score: Yup.number()
    .min(1, 'Must be greater than 0.')
    .required('Required'),
});

const mapComparator = val => {
  if (typeof val === 'string') {
    if (val === 'GREATER_THAN') {
      return { label: 'Greater Than (>)', value: 'GREATER_THAN' };
    } else {
      return { label: 'Less Than (<)', value: 'LESS_THAN' };
    }
  } else {
    return val;
  }
};

class SystemConfiguration extends Component {
  state = {};

  componentDidMount() {
    this.props.fetchAllConfigs();
  }

  handleSelectChange = (name, value, setter) => {
    setter(name, value.value);
  };

  handleSubmit = (values, actions) => {
    updateConfigs(values)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        this.props.fetchAllConfigs();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        actions.setSubmitting(false);
      });
  };

  render() {
    return (
      <PaddingWrapper padding="0 1rem 1rem">
        {this.props.configs.length !== 0 && (
          <Formik
            onSubmit={this.handleSubmit}
            validationSchema={ValidationSchema}
            initialValues={{
              ...this.props.configs,
            }}
            validateOnChange
            isInitialValid
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              setFieldValue,
              handleBlur,
            }) => (
              <Form>
                <FormGroup
                  label="Score Comparator"
                  style={{ maxWidth: '20rem' }}
                >
                  <Select
                    name="comparator"
                    options={[
                      { label: 'Greater Than (>)', value: 'GREATER_THAN' },
                      { label: 'Less Than (<)', value: 'LESS_THAN' },
                    ]}
                    value={mapComparator(values.comparator)}
                    onChange={val =>
                      this.handleSelectChange('comparator', val, setFieldValue)
                    }
                    isClearable={false}
                    styles={customStyles}
                  />
                </FormGroup>
                <FormGroup
                  label="Passing Score"
                  labelFor="max_passing_score_input"
                >
                  <InputGroup
                    large
                    id="max_passing_score_input"
                    name="max_passing_score"
                    value={values.max_passing_score}
                    style={{ maxWidth: '20rem' }}
                    onChange={handleChange}
                    type="number"
                    min={1}
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name="max_passing_score"
                    render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                  />
                </FormGroup>
                <FormGroup
                  label="Third Party Assessment Renewal Time (Days)"
                  labelFor="expiration_time"
                >
                  <InputGroup
                    large
                    id="expiration_time"
                    name="expiration_time"
                    value={values.expiration_time}
                    style={{ maxWidth: '20rem' }}
                    onChange={handleChange}
                    type="number"
                    min={1}
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name="expiration_time"
                    render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                  />
                </FormGroup>
                <FormGroup
                  label="Third Party Assessment Inactivity Expiration Time (Days)"
                  labelFor="days_until_expiration"
                >
                  <InputGroup
                    large
                    id="days_until_expiration"
                    name="days_until_expiration"
                    value={values.days_until_expiration}
                    style={{ maxWidth: '20rem' }}
                    onChange={handleChange}
                    type="number"
                    min={1}
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name="days_until_expiration"
                    render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                  />
                </FormGroup>
                <FormGroup
                  label="University of Rochester Contact Email"
                  labelFor="contact_email"
                >
                  <InputGroup
                    large
                    id="contact_email"
                    name="contact_email"
                    value={values.contact_email}
                    style={{ maxWidth: '20rem' }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name="contact_email"
                    render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                  />
                </FormGroup>
                <PlainButton
                  margin="0"
                  disabled={isSubmitting || !isValid}
                  type="submit"
                >
                  Submit
                </PlainButton>
              </Form>
            )}
          </Formik>
        )}
      </PaddingWrapper>
    );
  }
}

const mapStateToProps = state => ({
  configs: state.utils.configs,
  isFetching: state.utils.isFetching,
});

SystemConfiguration = connect(
  mapStateToProps,
  {
    fetchAllConfigs,
  }
)(SystemConfiguration);

export default SystemConfiguration;
